import { helpCenterLink, landingRoute } from './app';
import { isLandingPageEnabled } from './landing';

let menu = [
    {
        link: '/features',
        text: 'Features',
    },
    {
        link: '/download',
        text: 'Download',
    },
    {
        link: '/pricing',
        text: 'Pricing',
    },
    {
        link: helpCenterLink,
        text: 'Help',
        target: 'blank'
    },
];

if (isLandingPageEnabled) {
    menu = [{
        link: landingRoute,
        text: 'Bundle sale',
    }, ...menu];
}

export default menu;
